import Carousel from '../components/Carousel2';
import FAQSection from '../components/personas/CDTs/FAQ';
import Hero1 from '../components/Hero1';
import tuPension from '../assets/tuPension2.png';
import PensionSimulator from '../components/personas/Simulator';
import tuPension2 from '../assets/tuPension2.jpg';
import HeroB from '../components/HeroB';
import HorizontalList from '../components/horizontalList';

function TuPension() {
    const carouselItems = [
        { title: "Diagnóstico multiafiliado", description: "Conecta tus fondos obligatorios y voluntarios para ver cuánto tienes, cuánto te falta y qué rentabilidad estás obteniendo." },
        { title: "Simulador de escenarios", description: "Proyecta tus aportes mensuales, tasa esperada e inflación para saber a qué edad y con qué monto podrás pensionarte." },
        { title: "Alertas de aporte mínimo", description: "Recibe recordatorios cuando no realices aportes o cuando tu empleador esté atrasado, evitando perder semanas cotizadas." },
        { title: "Traslados acompañados", description: "Analiza comparativos entre fondos privados y Colpensiones y gestiona traslados con apoyo legal y operativo." },
        { title: "Fondos voluntarios curados", description: "Accede a convenios con fondos voluntarios que ofrecen incentivos tributarios y portafolios diversificados." },
        { title: "Reportes para tu futuro", description: "Genera reportes descargables para presentar a tu familia o asesor financiero y tomar decisiones informadas." },

    ];

    return (
        <div>
            <Hero1 imagen={tuPension} titulo="Tu pensión simplificada" descripcion="Organiza, consulta y optimiza todo desde un mismo espacio."/>
            <HorizontalList
                items={[
                    { label: "Simulador", targetId: "simulador" },
                    { label: "¿Cómo funciona?", targetId: "como-funciona" },
                    { label: "Beneficios", targetId: "beneficios" },
                    { label: "Preguntas frecuentes", targetId: "faq" }
                ]}
            />
            <section id="simulador" className="scroll-mt-48">
                <PensionSimulator />
            </section>
            <section id="como-funciona" className="scroll-mt-24">
                <HeroB
                    imagen={tuPension2}
                    titulo="¿Cómo funciona?"
                    items={[
                        "Ingresa tus datos y conectamos tus fondos obligatorios y voluntarios para un diagnóstico inicial.",
                        "Simula diferentes escenarios de aporte, rentabilidad e inflación para construir tu plan de retiro.",
                        "Recibe alertas y acompañamiento de expertos para traslados, aumentos de aporte y optimización tributaria."
                    ]}
                />
            </section>
            <section id="beneficios" className="scroll-mt-24">
                <Carousel items={carouselItems} />
            </section>
            <section id="faq" className="scroll-mt-24">
                <FAQSection />
            </section>
            <hr className="w-full border-t border-black" />
        </div>
    );
}
export default TuPension;
